import i18n from "../../../i18n";
import { hasProp } from "../../../helpers/Class";
import { formatPrice } from "../../../helpers/Billing";

class CarrierDestinationPrice {
    constructor(price = null) {
        this.id = !hasProp(price, "id") ? undefined : price.id;
        this.carrierDestinationId = !hasProp(price, "carrierDestinationId") ? undefined : price.carrierDestinationId;
        this.minWeight = !hasProp(price, "minWeight") ? null : price.minWeight;
        this.maxWeight = !hasProp(price, "maxWeight") ? null : price.maxWeight;
        this.minQuantity = !hasProp(price, "minQuantity") ? null : price.minQuantity;
        this.maxQuantity = !hasProp(price, "maxQuantity") ? null : price.maxQuantity;
        this.startingPrice = !hasProp(price, "startingPrice") ? undefined : price.startingPrice;
        this.firstProductIncludedInStartingPrice = !hasProp(price, "firstProductIncludedInStartingPrice") ? false : price.firstProductIncludedInStartingPrice;
        this.price = !hasProp(price, "price") ? undefined : price.price;
    }

    sanitizeForAPI(carrier) {
        if (carrier.chargesBy === "weight") {
            this.minQuantity = undefined;
            this.maxQuantity = undefined;
            this.firstProductIncludedInStartingPrice = undefined;
            this.startingPrice = undefined;
        } else {
            this.minWeight = undefined;
            this.maxWeight = undefined;
            if (carrier.chargesBy === "lot") {
                this.startingPrice = undefined;
                this.firstProductIncludedInStartingPrice = undefined;
            } else if (carrier.chargesBy === "quantity" && this.startingPrice === null) {
                this.firstProductIncludedInStartingPrice = undefined;
            }
        }
    }

    priceLabel(carrier, currencies) {
        let priceLabel = "";
        if (this.startingPrice) {
            priceLabel += `${formatPrice(parseFloat(this.startingPrice), carrier.currency, currencies)}`;
            priceLabel += ` (${i18n.t("CarrierDestinationPriceClass.startingPrice")}) + `;
        }
        priceLabel += formatPrice(parseFloat(this.price), carrier.currency, currencies);
        if (carrier.chargesBy === "weight") {
            priceLabel += ` ${i18n.t("CarrierDestinationPriceClass.forWeight")}`;
        } else if (carrier.chargesBy === "lot") {
            priceLabel += ` ${i18n.t("CarrierDestinationPriceClass.forLot")}`;
        } else if (carrier.chargesBy === "quantity") {
            if (this.firstProductIncludedInStartingPrice) {
                priceLabel += ` ${i18n.t("CarrierDestinationPriceClass.byAdditionalProduct")}`;
            } else {
                priceLabel += ` ${i18n.t("CarrierDestinationPriceClass.byProduct")}`;
            }
        }
        return priceLabel;
    }
}

export default CarrierDestinationPrice;